// West African country codes
export const COUNTRY_CODES = [
  { code: '+224', country: 'Guinee', flag: '🇬🇳', pattern: /^6\d{8}$/ },
  { code: '+221', country: 'Senegal', flag: '🇸🇳', pattern: /^7[0-8]\d{7}$/ },
  { code: '+223', country: 'Mali', flag: '🇲🇱', pattern: /^[\d]{8}$/ },
  { code: '+225', country: 'Cote d\'Ivoire', flag: '🇨🇮', pattern: /^[\d]{10}$/ },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫', pattern: /^[\d]{8}$/ },
  { code: '+229', country: 'Benin', flag: '🇧🇯', pattern: /^[\d]{8}$/ },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', pattern: /^[\d]{9}$/ },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', pattern: /^[\d]{10}$/ },
].sort((a, b) => a.country.localeCompare(b.country));

export function formatPhoneNumber(phone: string, countryCode: string): string {
  const cleaned = phone.replace(/\D/g, '');
  return `${countryCode}${cleaned}`;
}

export function validatePhoneNumber(phone: string, countryCode: string): boolean {
  const country = COUNTRY_CODES.find((c) => c.code === countryCode);
  if (!country) return false;

  const cleaned = phone.replace(/\D/g, '');
  return country.pattern.test(cleaned);
}

export function getCountryFromCode(code: string) {
  return COUNTRY_CODES.find((c) => c.code === code);
}

/** Longueur max du numéro local (sans indicatif). */
export function getPhoneMaxLength(countryCode: string): number {
  const patterns: Record<string, number> = {
    '+224': 9,
    '+221': 9,
    '+223': 8,
    '+225': 10,
    '+226': 8,
    '+229': 8,
    '+233': 9,
    '+234': 10,
  };
  return patterns[countryCode] ?? 12;
}

/** Affichage formaté du numéro local (ex. 620 00 00 01). */
export function formatPhoneDisplay(digits: string, countryCode: string): string {
  const cleaned = digits.replace(/\D/g, '');

  if (countryCode === '+224') {
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 5) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
    if (cleaned.length <= 7) return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5)}`;
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 7)} ${cleaned.slice(7, 9)}`;
  }

  if (countryCode === '+225' || countryCode === '+234') {
    return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  }

  return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
}

export function splitPhoneNumber(fullPhone: string): { countryCode: string; number: string } {
  // Try to match known country codes
  for (const country of COUNTRY_CODES) {
    if (fullPhone.startsWith(country.code)) {
      return {
        countryCode: country.code,
        number: fullPhone.slice(country.code.length),
      };
    }
  }

  // Default to Guinea if no match
  return {
    countryCode: '+224',
    number: fullPhone.replace(/\D/g, ''),
  };
}
